// no conflict
var $ = jQuery.noConflict();

$(document).ready(function() {

    var link = $('.menu-services a');
    var mega_menu = $('.mega-menu');

    // mouse enter
    link.mouseenter(function() {
        $('.mega-menu').addClass('is-active');
    });

    // mouse out
    link.mouseout(function() {            
        mega_menu.removeClass('is-active');
    });

    $('.header').mouseleave(function() {
        mega_menu.removeClass('is-active');
    });

});


// function add_sticky_nav() {

//   header_height = $('.header').outerHeight();
//   doc_scrollTop = $(document).scrollTop();

//   timeout = setTimeout(function() {
//       clearTimeout(timeout);
//       timeout = null;
      
//       if (doc_scrollTop > header_height ) {
//           $('.header,.mega-menu-wrap, .mobile-menu').addClass('is-sticky');
//       } else {
//           $('.header, .mega-menu-wrap, .mobile-menu').removeClass('is-sticky');
//       }
//   }, 100);

// }

// $(document).ready(function() {
//   add_sticky_nav();
// });

// $(window).scroll(function() {
//   add_sticky_nav();
// });